import React from 'react';
import Cookie from 'js-cookie';

const SetCookie = (cookieName, newValue) => {
    Cookie.set(cookieName, newValue, {
        //expire: 1,
        secure: false,
        sameSite: 'strict',
        path: '/'
    });
};

export default SetCookie;